import { render, staticRenderFns } from "./ModalRattachmentLoading.vue?vue&type=template&id=6826e354"
import script from "./ModalRattachmentLoading.vue?vue&type=script&lang=js"
export * from "./ModalRattachmentLoading.vue?vue&type=script&lang=js"
import style0 from "./ModalRattachmentLoading.vue?vue&type=style&index=0&id=6826e354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports